import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material';
import QRCode from 'react-qr-code';

interface QrCodeModalProps {
  open: boolean;
  onClose: () => void;
  /** URL, который кодируется в QR (по умолчанию — текущая страница). */
  url: string;
}

// Модалка с QR-кодом для продолжения на телефоне: пользователь сканирует код
// камерой телефона и открывает тот же экран на устройстве с рабочей камерой.
const QrCodeModal = ({ open, onClose, url }: QrCodeModalProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="qr-dialog-title">
    <DialogTitle id="qr-dialog-title">Открыть на телефоне</DialogTitle>
    <DialogContent>
      <Stack spacing={3} alignItems="center" sx={{ py: 1 }}>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Наведите камеру телефона на QR-код, чтобы продолжить на устройстве с рабочей камерой.
        </Typography>
        <Box
          sx={{
            p: 2,
            bgcolor: 'common.white',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'grey.200'
          }}
        >
          <QRCode value={url} size={200} />
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ wordBreak: 'break-all', textAlign: 'center' }}
        >
          {url}
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="inherit">
        Закрыть
      </Button>
    </DialogActions>
  </Dialog>
);

export default QrCodeModal;
